import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Price to show on shop cards/pages: "From" the cheapest size when sizes are priced, else the base price.
export function productPriceInfo(p) {
  const sizes = p?.size_options || [];
  const sizePrices = sizes.map((s) => Number(s.price)).filter((n) => n > 0);
  if (sizePrices.length) return { from: sizes.length > 1, amount: Math.min(...sizePrices) };
  const base = Number(p?.price);
  if (base > 0) return { from: false, amount: base };
  return null;
}
